export const PLATFORM_WEBSITES_RESET_STATE = 'PLATFORM_WEBSITES_RESET_STATE';
export const PLATFORM_WEBSITES_CURRENT_ITEM = 'PLATFORM_WEBSITES_CURRENT_ITEM';

export const PLATFORM_WEBSITES_REQUEST_LOADING = 'PLATFORM_WEBSITES_REQUEST_LOADING';
export const PLATFORM_WEBSITES_REQUEST_SUCCESS = 'PLATFORM_WEBSITES_REQUEST_SUCCESS';
export const PLATFORM_WEBSITES_REQUEST_FAILED = 'PLATFORM_WEBSITES_REQUEST_FAILED';

export const PLATFORM_WEBSITES_CURRENT_ACTION = 'PLATFORM_WEBSITES_CURRENT_ACTION';
export const PLATFORM_WEBSITES_RESET_ACTION = 'PLATFORM_WEBSITES_RESET_ACTION';